import { fuseFilter, nullOrUndefined } from '@/plugins/fuse'
import { SSharedList } from '@/services/shared'
import QUERY from 'lodash'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      fetching: {
        officerActivities: false
      },
      options: {
        officerActivities: []
      },
      selected: {
        activityType: '',
        officerActivity: '',
        schedule: ''
      },
      editable: {
        officerActivity: ''
      }
    }
  },

  computed: {
    ...mapGetters({
      currentUserRole: 'auth/user'
    })
  },

  methods: {

    async getOfficerActivities (context, search = '') {
      const selectedContext = context?.selected
      const fetchingContext = context?.fetching
      const optionsContext = context?.options

      if (nullOrUndefined(selectedContext) || nullOrUndefined(fetchingContext) || nullOrUndefined(optionsContext)) {
        throw Error('Invalid context object')
      }

      const selected = context.selected?.officerActivity
      const fetching = context.fetching?.officerActivities
      const options = context.options?.officerActivities
      const activityType = context.selected?.activityType
      const selectedSchedule = context.selected?.schedule

      if (nullOrUndefined(selected) || nullOrUndefined(fetching) || nullOrUndefined(options) || nullOrUndefined(selectedSchedule) || nullOrUndefined(activityType)) {
        throw Error('Invalid context object')
      }

      context.fetching.officerActivities = true
      context.selected.officerActivity = ''

      const filters = {
        filter_text: search,
        activity_type: context.selected?.activityType || '',
        schedule: context.selected?.schedule || '',
        role_id: 2
      }

      return await SSharedList.getOfficerActivities(filters).then(
        ({ data }) => {
          context.options.officerActivities = data
        }
      ).catch(() => {
        context.options.officerActivities = []
      }).finally(() => {
        context.fetching.officerActivities = false
      })
    },

    async searchOfficerActivities (search, loading) {
      this.searchOfficerActivitiesProvider(this, search, loading)
    },

    searchOfficerActivitiesProvider: QUERY.debounce(
      ({ options, selected }, search, loading) => {
        const filteredOptions = fuseFilter(search, options.officerActivities, {
          keys: ['activity_name']
        })

        if (filteredOptions.length < 1) {
          loading(true)

          const filters = {
            filter_text: search,
            schedule: selected?.schedule || '',
            role_id: 2
          }

          SSharedList.getOfficerActivities(filters).then(
            ({ data }) => {
              options.officerActivities = data
            }
          ).catch(() => {
            options.officerActivities = []
          }).finally(() => {
            loading(false)
          })
        }
      }, 500
    )
  }
}
